import type { AuthenticationState } from "../types";

const CONFIG: Record<AuthenticationState, { label: string; cls: string }> = {
  authenticated: { label: "Authenticated", cls: "badge-normal" },
  unauthenticated: { label: "Unauthenticated", cls: "badge-neutral" },
  invalidated: { label: "Invalidated", cls: "badge-danger" },
  revoked: { label: "Revoked", cls: "badge-danger" },
};

export function AuthenticationStatus({ state }: { state: AuthenticationState }) {
  const config = CONFIG[state];
  return (
    <span className={`badge ${config.cls}`}>
      <span className="badge-dot" />
      {config.label}
    </span>
  );
}
